"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAncestorsOf = exports.getRangeOf = exports.getNextSegment = exports.getPrevSegment = exports.getCursorSegment = exports.getLabelTextOf = exports.getInputValue = exports.getString24hr = exports.getString12hr = void 0;
var convert_1 = require("../convert/convert");
var regex_1 = require("../regex/regex");
var staticValues_1 = require("../staticValues");
var traverseSegmentRanges = function ($input, direction) {
    var cursorSegmentRange = exports.getRangeOf($input).cursorSegment();
    var currentType = cursorSegmentRange.segment;
    var modifier = direction === 'forward' ? 1 : -1;
    var nextTypeIndex = staticValues_1.rangesList.map(function (range) { return range.segment; }).indexOf(currentType) + modifier;
    return staticValues_1.rangesList[nextTypeIndex] || cursorSegmentRange;
};
exports.getString12hr = function (string12hr) {
    var timeObject = convert_1.convertString12hr(string12hr).toTimeObject();
    return __assign(__assign({}, timeObject), { timeObject: timeObject });
};
exports.getString24hr = function (string24hr) {
    var timeObject = convert_1.convertString24hr(string24hr).toTimeObject();
    return __assign(__assign({}, timeObject), { timeObject: timeObject });
};
exports.getInputValue = function ($input) {
    var value = ($input === null || $input === void 0 ? void 0 : $input.value) || '';
    var is12hrTime = regex_1.regex.string12hr.test(value);
    var is24hrTime = regex_1.regex.string24hr.test(value);
    return {
        as12hrString: function () { return (is12hrTime ? value : convert_1.convertString24hr(value).to12hr()); },
        as24hrString: function () { return (is24hrTime ? value : convert_1.convertString12hr(value).to24hr()); },
        asTimeObject: function () {
            return is12hrTime
                ? convert_1.convertString12hr(value).toTimeObject()
                : convert_1.convertString24hr(value).toTimeObject();
        },
    };
};
exports.getLabelTextOf = function ($input, document) {
    if (document === void 0) { document = window.document; }
    if (!$input)
        return '';
    var labelText = aria_labelledby($input, document) ||
        aria_label($input) ||
        for_attribute($input, document) ||
        label_wrapper_element($input) ||
        title_attribute($input);
    if (labelText)
        return labelText;
    console.error('Label text for input not found.', $input);
    throw new Error('Cannot polyfill time input due to a missing label.');
};
exports.getCursorSegment = function ($input) {
    return exports.getRangeOf($input).cursorSegment().segment;
};
exports.getPrevSegment = function ($inputOrSegment) {
    if (typeof $inputOrSegment === 'string') {
        if ($inputOrSegment === 'hrs12')
            return 'hrs12';
        if ($inputOrSegment === 'minutes')
            return 'hrs12';
        if ($inputOrSegment === 'mode')
            return 'minutes';
    }
    return exports.getRangeOf($inputOrSegment).prevSegment().segment;
};
exports.getNextSegment = function ($inputOrSegment) {
    if (typeof $inputOrSegment === 'string') {
        if ($inputOrSegment === 'hrs12')
            return 'minutes';
        if ($inputOrSegment === 'minutes')
            return 'mode';
        if ($inputOrSegment === 'mode')
            return 'mode';
    }
    return exports.getRangeOf($inputOrSegment).nextSegment().segment;
};
exports.getRangeOf = function ($input) { return ({
    rawSelection: function () {
        if (!$input) {
            return {
                start: 0,
                end: 0,
                segment: 'hrs12',
            };
        }
        var within = function (segment, value) {
            return staticValues_1.ranges[segment].start <= value && value <= staticValues_1.ranges[segment].end;
        };
        var start = $input.selectionStart;
        var end = $input.selectionEnd;
        var segment = (within('mode', start) && 'mode') || (within('minutes', start) && 'minutes') || 'hrs12';
        return {
            start: start,
            end: end,
            segment: segment,
        };
    },
    cursorSegment: function () {
        var segment = exports.getRangeOf($input).rawSelection().segment;
        return staticValues_1.ranges[segment];
    },
    nextSegment: function () { return traverseSegmentRanges($input, 'forward'); },
    prevSegment: function () { return traverseSegmentRanges($input, 'backward'); },
}); };
exports.getAncestorsOf = function ($startingElem, selectorString) {
    // https://stackoverflow.com/a/8729274/1611058
    var $elem = $startingElem;
    var ancestors = [];
    var i = 0;
    while ($elem) {
        if (i !== 0) {
            ancestors.push($elem);
        }
        if (selectorString) {
            var matchesSelector = $elem.msMatchesSelector
                ? $elem.msMatchesSelector(selectorString) // IE Hack
                : $elem.matches(selectorString);
            if (matchesSelector) {
                return ancestors;
            }
        }
        $elem = $elem === null || $elem === void 0 ? void 0 : $elem.parentElement;
        i++;
    }
    return ancestors;
};
var elemText = function ($elem) { var _a; return ((_a = $elem === null || $elem === void 0 ? void 0 : $elem.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || ''; };
function aria_labelledby($input, document) {
    if (document === void 0) { document = window.document; }
    var ariaLabelByID = $input === null || $input === void 0 ? void 0 : $input.getAttribute('aria-labelledby');
    if (ariaLabelByID) {
        var $ariaLabelBy = document.getElementById(ariaLabelByID);
        return elemText($ariaLabelBy);
    }
    return '';
}
function aria_label($input) {
    var ariaLabel = $input.getAttribute('aria-label');
    return ariaLabel || '';
}
function for_attribute($input, document) {
    if (document === void 0) { document = window.document; }
    var $forLabel = (document.querySelector('label[for="' + $input.id + '"]'));
    return elemText($forLabel);
}
function label_wrapper_element($input) {
    var ancestors = exports.getAncestorsOf($input, 'label');
    var $parentLabel = ancestors[ancestors.length - 1];
    if ($parentLabel.nodeName == 'LABEL')
        return elemText($parentLabel);
    return '';
}
function title_attribute($input) {
    var titleLabel = $input.getAttribute('title');
    return titleLabel || '';
}
